var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E6F2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9815 42.1012L33.6342 37.7776C33.2279 37.3735 32.7404 37.1715 32.1717 37.1715C31.6029 37.1715 31.1154 37.3735 30.7092 37.7776C30.3029 38.1816 30.0998 38.6699 30.0998 39.2424C30.0998 39.815 30.3029 40.3032 30.7092 40.7073L36.4373 46.4649C36.8435 46.8689 37.3176 47.0709 37.8596 47.0709C38.4011 47.0709 38.875 46.8689 39.2812 46.4649L50.2908 35.5152C50.6971 35.1111 50.9002 34.6297 50.9002 34.0709C50.9002 33.5117 50.6971 33.0436 50.2908 32.6667C49.9114 32.2897 49.434 32.1079 48.8588 32.1212C48.2831 32.1345 47.8058 32.3299 47.4268 32.7073L37.9815 42.1012ZM40.5 64C40.2697 64 40.0529 63.9798 39.8498 63.9394C39.6467 63.899 39.4368 63.8384 39.2203 63.7576C33.6275 61.8857 29.1926 58.4952 25.9158 53.5861C22.6386 48.677 21 43.3267 21 37.5352V25.7982C21 24.9497 21.2472 24.182 21.7416 23.4952C22.2356 22.8083 22.8685 22.3099 23.6404 22L39.0783 16.2624C39.5658 16.0875 40.0397 16 40.5 16C40.9603 16 41.4342 16.0875 41.9217 16.2624L57.3596 22C58.1315 22.3099 58.7644 22.8083 59.2584 23.4952C59.7528 24.182 60 24.9497 60 25.7982V37.5352C60 43.3267 58.3614 48.677 55.0842 53.5861C51.8074 58.4952 47.3725 61.8857 41.7797 63.7576C41.5632 63.8384 41.3533 63.899 41.1502 63.9394C40.9471 63.9798 40.7303 64 40.5 64Z",
    fill: "#057C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.e0ebec58684f6673e093f72997805e02.svg";
export { ForwardRef as ReactComponent };